import { Category } from '@forms-exp/types';

export const DEFAULT_CATEGORIES: Category[] = [];
